<template>
  <div class="has-border-b filters white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div v-if="false" class="filters-item filters-item--search filters-item--reset">
      <v-text-field
        v-model="filters.search"
        :placeholder="$t('Views.CompanyPage.companies.placeholder')"
        prepend-inner-icon="search"
        :disabled="!isSuccess"
        :loading="searchIsLoading"
        color="accent"
        height="36"
        flat
        solo
        clearable
        hide-details
        @input="handleSearch"
      />
    </div>

    <div class="filters-item">
      <MenuItemAutocomplete
        :label="$t(`${namespace}.requester`)"
        :profiles="['FinancialAdmin']"
        :placeholder="$t(`${namespace}.requesterPlaceholder`)"
        type="useremail"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemPeriod
        type="createDate"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemStatus
        :status="status"
        :items="statusList"
        @change="updateFilters"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { objectToArray } from 'utils/functions'
import MenuItemStatus from '../MenuItemStatus'
import MenuItemPeriod from '../MenuItemPeriod'
import MenuItemAutocomplete from 'components/filters/MenuItemAutocomplete'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  components: {
    MenuItemStatus,
    MenuItemPeriod,
    MenuItemAutocomplete
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    },

    statusList () {
      return objectToArray(this.$t('Views.PaymentStatusPage.filters.importedSpreadsheetsStatus'))
    }
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage',
      filters: {
        search: null,
        status: null,
        updateDate: null,
        massiveUpdate: false
      }
    }
  },
  methods: {
    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    updateFilters (val) {
      this.filters = {
        ...this.filters,
        ...val
      }

      this.emitEvent()
    }
  }
}
</script>
